module.exports = __webpack_public_path__ + "img/toplogo.5596deb4.png";